const multasCategories = {
  'Excesso de Peso': [
    'excesso de peso',
    'excesso',
    'peso',
    'pbt',
    'pbtc',
    'eixo'
  ],
  'Não Identificação do Condutor': [
    'não identificação',
    'nao identificacao',
    'identificação do condutor',
    'identificacao do condutor',
    'imposta à pessoa jurídica',
    'imposta a pessoa juridica'
  ],
  'Transitar com Veículo': [
    'transitar com',
    'transitar com o veic',
    'transitar com o veiculo'
  ],
  'Carga': [
    'cargas',
    'carga'
  ]
}

export const groupMultasByCategory = (data) => {
  if (!data || data.length === 0) return []

  const grouped = {}

  data.forEach(item => {
    const descricao = (item.descricao || '').toLowerCase()
    let categoryFound = false

    for (const [category, keywords] of Object.entries(multasCategories)) {
      const matchesKeyword = keywords.some(keyword =>
        descricao.includes(keyword.toLowerCase())
      )

      if (matchesKeyword) {
        if (!grouped[category]) {
          grouped[category] = {
            descricao: category,
            count: 0,
            sum: 0,
            items: []
          }
        }

        grouped[category].count += item.count || 0
        grouped[category].sum += item.sum || 0
        grouped[category].items.push(item)
        categoryFound = true
        break
      }
    }

    if (!categoryFound) {
      const originalDesc = item.descricao || 'SEM CLASSIFICAÇÃO'
      if (!grouped[originalDesc]) {
        grouped[originalDesc] = {
          descricao: originalDesc,
          count: item.count || 0,
          sum: item.sum || 0,
          items: [item]
        }
      } else {
        grouped[originalDesc].count += item.count || 0
        grouped[originalDesc].sum += item.sum || 0
        grouped[originalDesc].items.push(item)
      }
    }
  })

  return Object.values(grouped).sort((a, b) => b.count - a.count)
}

export const getMultaDetails = (groupedItem) => {
  return groupedItem.items || []
}
